import React, { Component } from 'react';
import './sidebar-rounded-icons.css';

export default class SidebarRoundedIcons extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "color": "#FFF"
    }
  }

  componentWillMount() {

  }

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  isActive(path) {
    const currentHash = window.location.hash.replace('#', '');
    if (path === '' && (currentHash === '' || currentHash === '/')) {
      return true;
    }
    return currentHash === path;
  }

  render() {
    return (
      <ul className="rdp-react-template-component-sidebar-rounded-icons" role="navigation" aria-label="Navegação Principal">
        <li className={`rdp-react-template-component-sidebar-rounded-icons-item ${this.isActive('') ? 'active' : ''}`} onClick={() => this.redirectTo('')} role="button" tabIndex="0" aria-label="Início" onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (e.key === ' ') e.preventDefault();
            this.redirectTo('');
          }
        }}>
          <span className="rdp-react-template-component-sidebar-rounded-icons-item-icon home">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
              <path fill="#024980" d="M25.16,13.82L15.59,5.51c-.34-.29-.84-.29-1.18,0L4.84,13.83c-.37.32-.41.89-.09,1.26.17.19.41.31.67.31h2.37v8.41c0,.49.4.9.9.9h3.38c.49,0,.9-.4.9-.9,0,0,0,0,0,0v-5.93h3.95v5.93c0,.49.4.9.9.9h3.33c.49,0,.9-.4.9-.9,0,0,0,0,0,0v-8.41h2.53c.49,0,.9-.4.9-.9,0-.26-.11-.51-.31-.68ZM22.01,14.46c-.49,0-.9.4-.9.9v8.41h-3.26v-5.93c0-.5-.4-.9-.9-.9,0,0,0,0,0,0h-4.02c-.49,0-.9.4-.9.9v5.93h-3.3v-8.41c0-.49-.4-.9-.9-.9h-2.31L15,6.23l9.48,8.23h-2.47Z" />
            </svg>
          </span>
        </li>

        <li className={`rdp-react-template-component-sidebar-rounded-icons-item ${this.isActive('/library/bookmarks') ? 'active' : ''}`} onClick={() => this.redirectTo('/library/bookmarks')} role="button" tabIndex="0" aria-label="Favoritos" onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (e.key === ' ') e.preventDefault();
            this.redirectTo('/library/bookmarks');
          }
        }}>
          <span className="rdp-react-template-component-sidebar-rounded-icons-item-icon favoritos">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="2 0 30 30">
              <path fill="#024980" d="M11,24.66c-.76,0-1.37-.62-1.37-1.37,0,0,0-.01,0-.02l.14-5.45-3.19-4.37c-.45-.61-.32-1.47.3-1.92.12-.09.26-.16.4-.2l4.99-1.54,2.9-4.43c.25-.39.68-.62,1.15-.62h0c.46,0,.89.23,1.15.62l2.9,4.43,4.99,1.54c.72.22,1.13.99.9,1.71-.05.15-.11.28-.21.41l-3.2,4.35.14,5.45c.02.76-.57,1.39-1.33,1.41-.18,0-.36-.03-.53-.09l-4.82-1.8-4.83,1.8c-.15.06-.32.09-.48.09ZM16.31,5.67c-.15,0-.29.07-.37.2l-2.99,4.57c-.06.09-.15.16-.25.19l-5.14,1.59c-.14.04-.25.15-.29.28-.05.14-.02.29.06.4l3.29,4.48c.06.08.09.18.09.29l-.15,5.61c0,.15.06.29.18.37.12.09.27.11.41.06l4.99-1.86c.1-.04.22-.04.33,0l4.99,1.86c.23.08.48-.03.57-.26.02-.05.03-.11.03-.16l-.15-5.61c0-.1.03-.2.09-.29l3.29-4.48c.08-.12.11-.26.06-.4-.04-.14-.15-.24-.29-.28l-5.15-1.59c-.1-.03-.19-.1-.25-.19l-2.99-4.57c-.08-.13-.22-.2-.37-.2Z" />
            </svg>
          </span>
        </li>

        <li className={`rdp-react-template-component-sidebar-rounded-icons-item ${this.isActive('/library/notes') ? 'active' : ''}`} onClick={() => this.redirectTo('/library/notes')} role="button" tabIndex="0" aria-label="Marcações" onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (e.key === ' ') e.preventDefault();
            this.redirectTo('/library/notes');
          }
        }}>
          <span className="rdp-react-template-component-sidebar-rounded-icons-item-icon marcadores">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="1 0 30 30">
              <path fill="#024980" d="M9.23,25.31c-.18,0-.35-.04-.51-.11-.43-.19-.7-.62-.7-1.09V5.88c0-.66.54-1.19,1.2-1.19h11.55c.66,0,1.2.53,1.2,1.19v18.23c0,.66-.54,1.2-1.21,1.2-.29,0-.57-.11-.79-.3h0l-4.77-4.19c-.11-.09-.26-.09-.37,0l-4.83,4.2c-.22.19-.5.3-.79.3ZM9.23,5.62c-.15,0-.27.11-.28.26,0,0,0,0,0,0v18.24c0,.1.06.19.16.23.1.05.22.04.31-.04l4.82-4.2c.46-.4,1.13-.4,1.59,0l4.77,4.19c.08.07.2.09.3.04.09-.04.16-.13.16-.23V5.88c0-.15-.12-.27-.27-.26h0s-11.55,0-11.55,0Z" />
            </svg>
          </span>
        </li>

        <li className={`rdp-react-template-component-sidebar-rounded-icons-item ${this.isActive('/library/reading-list') ? 'active' : ''}`} onClick={() => this.redirectTo('/library/reading-list')} role="button" tabIndex="0" aria-label="Listas de Leitura" onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (e.key === ' ') e.preventDefault();
            this.redirectTo('/library/reading-list');
          }
        }}>
          <span className="rdp-react-template-component-sidebar-rounded-icons-item-icon listas-de-leitura">
            <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
              <circle fill="#024980" cx="7.02" cy="13.92" r="1" />
              <circle fill="#024980" cx="7.02" cy="17.92" r="1" />
              <circle fill="#024980" cx="7.02" cy="21.92" r="1" />
              <path fill="#024980" d="M21.26,14.32h-11.74c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h11.74c.22,0,.4.18.4.4s-.18.4-.4.4Z" />
              <circle fill="#024980" cx="7.02" cy="9.92" r="1" />
              <path fill="#024980" d="M21.26,10.32h-11.74c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h11.74c.22,0,.4.18.4.4s-.18.4-.4.4Z" />
              <path fill="#024980" d="M21.26,18.32h-11.74c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h11.74c.22,0,.4.18.4.4s-.18.4-.4.4Z" />
              <path fill="#024980" d="M21.26,22.32h-11.74c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h11.74c.22,0,.4.18.4.4s-.18.4-.4.4Z" />
            </svg>
          </span>
        </li>










      </ul>
    );
  }
}